import React from 'react';
import FalconComponentCard from 'components/common/FalconComponentCard';
import IconButton from 'components/common/IconButton';

import {Axios} from 'helpers/axios';
import HabilitationService from 'services/habilitationsService';

const Password = () => {
    const requestReset = async () => {
        try {
            await Axios.get('/authenticatedRoutes/settingsCompte/resetPasswordClient');
            HabilitationService.disconnect();
            location.reload();
        } catch (error) {
            console.error(error)
        }
    }

    return (
        <>
            <FalconComponentCard>
                <FalconComponentCard.Header
                    title="Réinitialiser mon mot de passe"
                >
                </FalconComponentCard.Header>
                <FalconComponentCard.Body>
                    <p><center>Pour changer votre mot de passe, veuillez cliquer sur le bouton ci-dessous afin de recevoir un email d'initialisation.</center></p>

                    <center>
                        <IconButton
                            icon={'envelope'}
                            size='sm'
                            onClick={requestReset}
                            bg='outline-primary'
                        >Déclencher le mail de réinitialisation</IconButton>
                    </center>
                </FalconComponentCard.Body>
            </FalconComponentCard>
        </>
    );
};

Password.propTypes = {};

export default Password;